import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LogService } from 'src/app/services/log.service';
import { TankService } from 'src/app/services/tank.service';
import { DropDown } from 'src/app/interfaces/drop-down.interface';

export const TANK_FORM_CONTROL_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TankFormFieldComponent),
  multi: true,
};

@Component({
  selector: 'app-tank-form-field',
  providers: [TANK_FORM_CONTROL_ACCESSOR],
  templateUrl: './tank-form-field.component.html',
  styleUrls: ['./tank-form-field.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TankFormFieldComponent
  implements ControlValueAccessor, OnChanges, AfterViewInit
{
  @ViewChild('tankField') tankField: any;
  @Input() locationId: number = null;

  options: DropDown<number>[] = null;
  fields: Object = { value: 'value', text: 'text' };
  loading: boolean = false;
  _value: DropDown<number> | null = null;

  private _disabled: boolean = false;
  public get disabled(): boolean {
    return this._disabled || this.loading;
  }
  @Input() public set disabled(value: boolean) {
    this._disabled = value;
  }

  constructor(
    private _ts: TankService,
    private _lgr: LogService,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.updateTankFieldValue();
  }

  // Function to call when the input changes.
  onChange = (value: DropDown<number> | null) => {};

  // Function to call when the input is touched.
  onTouched = () => {};

  // Allows Angular to update the model (organizationControl).
  // Update the model and changes needed for the view here.
  writeValue(value: DropDown<number> | null): void {
    this._value = value;
    this.updateTankFieldValue();
    this.onChange(value);
  }

  // Allows Angular to register a function to call when the model (organizationControl) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this._cdr.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!changes.locationId)
      return;

    if (!this.locationId) {
      this.options = null;
      this.writeValue(null);
    } else
      this.loadOptions();

  }

  onTankChange($event: { itemData: DropDown<number> }) {
    this._value = $event.itemData;
    this.onTouched();
    this.onChange($event.itemData);
  }

  private loadOptions() {
    this.loading = true;
    this._cdr.markForCheck();
    this._ts
      .getTanksForDropDownByLocationId(this.locationId)
      .subscribe((tanks) => {
        this.options = tanks;
        this._lgr.log('Tanks form field ngOnChanges ', tanks);
        this.writeValue(null); //reset the value
        this.loading = false;
        setTimeout(() => {
          this._cdr.detectChanges();
        }, 50);
      });
  }

  private updateTankFieldValue() {
    if (this.tankField) {
      if (this._value?.value) {
        this.tankField.value = this._value?.value;
      } else {
        this.tankField.index = null;
      }
    }
  }

}
